import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { route as routePropType } from 'common/propTypes';
import { managePermission } from 'payments/propTypes';
import { ordersRoute } from 'app/containers/routes';
import { selectors as authSelectors } from 'auth';

import RewardsPage from './Rewards';

const Routes = ({ match, rewardsPermission, isFetching }) => {
  if (isFetching) return null;

  const canManageRewards = rewardsPermission === managePermission;

  if (!canManageRewards) {
    return <Redirect to={ordersRoute} />;
  }

  return (
    <Switch>
      <Route exact path={match.path} component={RewardsPage} />
    </Switch>
  );
};

Routes.propTypes = {
  ...routePropType,
  rewardsPermission: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

const ConnectedRoutes = connect((state) => {
  const { loading: isFetching, rewards: rewardsPermission } =
    authSelectors.getPermissions(state);

  return {
    rewardsPermission,
    isFetching: !!isFetching,
  };
})(Routes);

export default ConnectedRoutes;
